import React, { useState } from 'react';
import { auth } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { Link } from 'react-router-dom'; // 🔥 1. ضفنا استيراد اللينك
import { useI18n } from './i18n';

// استيراد الصور من مجلد assets
import dafagencyLogo from './assets/dafagency_logo.png';
import loginBackground from './assets/background_login.jpg';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useI18n();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error("Login Error:", err.code, err.message);
      if (err.code === 'auth/invalid-email' || err.code === 'auth/wrong-password' || err.code === 'auth/user-not-found' || err.code === 'auth/invalid-credential') {
          setError("الإيميل أو الباسورد غلط، حاول تاني.");
      } else if (err.code === 'auth/too-many-requests') {
          setError("محاولات كتير غلط، استنى شوية وحاول تاني.");
      } else {
          setError("حصل خطأ غير متوقع، حاول تاني.");
      }
    } finally {
        setLoading(false);
    }
  };

  return (
    <div style={loginStyles.backgroundContainer}>
      <div style={loginStyles.overlay}></div>
      <div style={loginStyles.loginCard}>
        <img src={dafagencyLogo} alt="Dafagency.ai Logo" style={loginStyles.logo} />

        <h2 style={{ marginBottom: '30px', fontWeight: 'normal' }}>{t('login.title')}</h2>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('login.email')}
            required
            style={loginStyles.input}
            disabled={loading}
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t('login.password')}
            required
            style={loginStyles.input}
            disabled={loading}
          />
          <button type="submit" style={loginStyles.button} disabled={loading}>
            {loading ? t('login.loading') : t('login.submit')}
          </button>
          {error && <p style={loginStyles.errorText}>{error}</p>}
        </form>

        {/* 🔥 2. ضفنا برجراف التسجيل الجديد هنا */}
        <p style={loginStyles.signupText}>
          {t('login.signupPrompt')}{' '}
          <Link to="/signup" style={loginStyles.signupLink}>
            {t('login.signupCta')}
          </Link>
        </p>

      </div>
    </div>
  );
}

// الستايلات الجديدة لشاشة اللوجن
const loginStyles = {
  backgroundContainer: {
    backgroundImage: `url(${loginBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  overlay: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 1,
  },
  loginCard: {
    position: 'relative',
    zIndex: 2,
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(15px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '15px',
    padding: '40px 30px',
    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
    maxWidth: '400px',
    width: '90%',
    textAlign: 'center',
    color: 'white',
  },
  logo: {
    width: '130px',
    height: 'auto',
    marginBottom: '25px',
  },
  input: {
    display: 'block',
    width: 'calc(100% - 22px)',
    padding: '12px 10px',
    marginBottom: '15px',
    fontSize: '16px',
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '5px',
    color: 'white',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.3s ease',
  },
  button: {
    display: 'block',
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    fontWeight: 'bold',
    background: '#00BFFF',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '10px',
    transition: 'background-color 0.3s ease',
  },
  errorText: {
    color: '#ff8a80',
    textAlign: 'center',
    marginTop: '15px',
    fontSize: '14px',
  },
  // 🔥 3. ضفنا الستايلات دي للينك الجديد
  signupText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '14px',
    marginTop: '20px',
  },
  signupLink: {
    color: '#00BFFF', // نفس لون الزرار
    textDecoration: 'underline',
    fontWeight: 'bold',
  }
};

export default LoginPage;